import { ALL_TIME_GREATS_STATS } from "../../constants/allTimeGreats";
import { NBA_ALL_TIME_GREATS_STATS } from "../../constants/nbaAllTimeGreats";
import { NFL_ALL_TIME_GREATS_STATS } from "../../constants/nflAllTimeGreats";

export const MAX_INSPIRATION_PLAYERS = 10;

/** Hitting + pitching rails restored from the pre-streamline Compare "Popular Players" pattern. */
export const MLB_COMPARE_INSPIRATION_KEYS = [
  "home-runs",
  "batting-average",
  "rbi",
  "hits",
  "wins",
  "era",
  "pitching-strikeouts",
  "saves",
];

export const NBA_COMPARE_INSPIRATION_KEYS = [
  "points",
  "rebounds",
  "assists",
  "steals",
  "blocks",
  "ppg",
];

export const NFL_COMPARE_INSPIRATION_KEYS = [
  "passing-yards",
  "rushing-yards",
  "receiving-yards",
  "passing-tds",
  "receptions",
  "receiving-tds",
];

export const MLB_COMPARE_TAB_LABELS = {
  "home-runs": "HR",
  "batting-average": "BA",
  rbi: "RBI",
  hits: "Hits",
  wins: "Wins",
  era: "ERA",
  "pitching-strikeouts": "K",
  saves: "Saves",
};

export const NBA_COMPARE_TAB_LABELS = {
  points: "Points",
  rebounds: "Rebounds",
  assists: "Assists",
  steals: "Steals",
  blocks: "Blocks",
  ppg: "PPG",
};

export const NFL_COMPARE_TAB_LABELS = {
  "passing-yards": "Pass Yds",
  "rushing-yards": "Rush Yds",
  "receiving-yards": "Rec Yds",
  "passing-tds": "Pass TD",
  receptions: "Rec",
  "receiving-tds": "Rec TD",
};

export const MLB_COMPARE_PRESETS = [
  { label: "Aaron vs Bonds", players: ["aaronha01", "bondsba01"] },
  { label: "Ruth vs Mays", players: ["ruthba01", "mayswi01"] },
];

export function getCompareInspirationSections(keys, statsByKey, tabLabels = {}) {
  return keys.map((key) => {
    const config = statsByKey[key] || {};
    return {
      id: key,
      label: config.label || config.railLabel || key,
      tabLabel: tabLabels[key] || config.railLabel || config.label || key,
    };
  });
}

export function getMlbCompareInspirationSections() {
  return getCompareInspirationSections(
    MLB_COMPARE_INSPIRATION_KEYS,
    ALL_TIME_GREATS_STATS,
    MLB_COMPARE_TAB_LABELS
  );
}

export function getNbaCompareInspirationSections() {
  return getCompareInspirationSections(
    NBA_COMPARE_INSPIRATION_KEYS,
    NBA_ALL_TIME_GREATS_STATS,
    NBA_COMPARE_TAB_LABELS
  );
}

export function getNflCompareInspirationSections() {
  return getCompareInspirationSections(
    NFL_COMPARE_INSPIRATION_KEYS,
    NFL_ALL_TIME_GREATS_STATS,
    NFL_COMPARE_TAB_LABELS
  );
}

export function toInspirationPlayer(row) {
  if (!row) return null;
  const playerId = row.playerId || row.id || null;
  if (!playerId) return null;
  return {
    playerId,
    name:
      row.playerName ||
      row.name ||
      row.displayName ||
      row.bio?.displayName ||
      row.bioData?.displayName ||
      null,
  };
}

export function filledCompareSlotCount(selectedIds = []) {
  return selectedIds.filter(Boolean).length;
}

export function shouldCollapseInspiration(selectedIds = []) {
  return filledCompareSlotCount(selectedIds) >= 2;
}

export function visibleInspirationSections(sections = [], leadersByStat = {}) {
  return sections.filter((section) => {
    const entry = leadersByStat[section.id];
    if (!entry || entry.loading || !entry.players) return true;
    return entry.players.some((row) => toInspirationPlayer(row));
  });
}

export function resolveActiveInspirationStat(visibleSections, activeId) {
  if (visibleSections.some((section) => section.id === activeId)) return activeId;
  return visibleSections[0]?.id || null;
}

export function inspirationPlayerRowsFromLeaders(entry) {
  if (!entry?.players) return [];
  return entry.players
    .map((row) => {
      const player = toInspirationPlayer(row);
      return player ? { row, player } : null;
    })
    .filter(Boolean)
    .slice(0, MAX_INSPIRATION_PLAYERS);
}

export function isMatchupSelected(matchup, selectedIds = []) {
  const selected = new Set(selectedIds.filter(Boolean));
  return Boolean(matchup?.players?.length) &&
    matchup.players.every((id) => selected.has(id));
}
